import RequestUtil from "../utils/RequestUtil";
import Requests from "./Requests";

const basePath = "/cia/banner/";

export type PositionRules = {
    pageToType: {
        [key: string]: string[];
    };
    typeToPage: {
        [key: string]: string[];
    };
};

const service = {
    getPositionRules(country: string): PositionRules {
        const url = basePath + "positionrules?country=" + encodeURIComponent(country);
        return Requests.get(url, null, { timeout: 3000, headers: RequestUtil.makeCallTreeHeader() });
    }
};

export default service;
